import NamedDto from 'modules/base/dto/NamedDto';

export class FitterLogFieldEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
	}

	/**
	 * @typedef {Object} _FitterLogFieldEditDtoProps
	 * @property {string} type
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _FitterLogFieldEditDtoProps} FitterLogFieldEditDtoProps
	 */
	/**
	 *
	 * @param {FitterLogFieldEditDtoProps} props
	 * @returns {FitterLogFieldEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		return this;
	}
}

export default FitterLogFieldEditDto;
